export default __webpack_public_path__ + "static/media/news5.d697349e.png";